"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _i18n = _interopRequireDefault(require("@/i18n"));
var _report = require("@/api/report");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Pagination from '@/components/Pagination'
var _default = {
  /* components: {
      Pagination
    }, */
  data() {
    return {
      uuid: this.$route.params.id,
      list: null,
      listLoading: false,
      listQuery: {
        fromTime: null,
        toTime: null,
        groupBy: 'week',
        page: 1,
        limit: 9999
      },
      groupByOptions: [{
        key: 'daily_session',
        name: 'Session'
      }, {
        key: 'hour',
        name: 'Hour'
      }, {
        key: 'date',
        name: 'Day'
      }, {
        key: 'week',
        name: 'Week'
      }, {
        key: 'month',
        name: 'Month'
      }, {
        key: 'year',
        name: 'Year'
      }],
      total: 0
    };
  },
  computed: {
    ...(0, _vuex.mapGetters)([
    // 'name',
    'user'])
  },
  async created() {
    const today = new Date();
    this.listQuery['fromTime'] = new Date(today.getFullYear(), today.getMonth(), 1);
    this.listQuery['toTime'] = new Date(today.getFullYear(), today.getMonth() + 1, -1);
    this.listQuery['toTime'].setDate(this.listQuery.toTime.getDate() + 1);
    this.fetchData();
  },
  methods: {
    fetchData() {
      const param = {};
      let current_datetime = new Date();
      for (const key in this.listQuery) {
        if (!this.listQuery[key]) {
          continue;
        }
        if (key === 'fromTime' || key === 'toTime') {
          current_datetime = this.listQuery[key];
          param[key] = current_datetime.getFullYear() + '-' + (current_datetime.getMonth() + 1) + '-' + current_datetime.getDate() + ' ' + current_datetime.getHours() + ':' + current_datetime.getMinutes() + ':' + current_datetime.getSeconds();
        } else {
          param[key] = this.listQuery[key];
        }
      }
      this.listLoading = true;
      (0, _report.getSaleVSLavourCost)({
        ...param
      }).then(response => {
        this.list = response.data;
        this.total = response.data ? response.data.length : 0;
      }).finally(() => {
        this.listLoading = false;
      });
    },
    getSummaries() {
      const summary = {};
      let totalActualSale = 0;
      let totalEstimatedSale = 0;
      let totalDutyCost = 0;
      let totalDutyManHr = 0;
      let actualSaleCount = 0;
      let estimatedSaleCount = 0;
      let dutyCostCount = 0;
      let dutyManHrCount = 0;
      if (this.list) {
        this.list.forEach(row => {
          if (row.actualSale) {
            totalActualSale += row.actualSale;
            actualSaleCount++;
          }
          if (row.estimatedSale) {
            totalEstimatedSale += row.estimatedSale;
            estimatedSaleCount++;
          }
          /* if (row.dutyCost) {
                      totalEstimatedSale += Math.ceil(row.dutyCost / 0.3)
                      estimatedSaleCount++
                    }*/
          if (row.dutyCost) {
            totalDutyCost += row.dutyCost;
            dutyCostCount++;
          }
          if (row.dutyManHr) {
            totalDutyManHr += row.dutyManHr ? parseFloat(row.dutyManHr.toString()) : 0;
            dutyManHrCount++;
          }
        });
      }

      // console.log(totalDutyManHr)

      summary[2] = _i18n.default.t('Order.Total') + ': $' + totalEstimatedSale.toFixed(0) + ' | Avg: $' + (estimatedSaleCount ? totalEstimatedSale / estimatedSaleCount : 0).toFixed(0);
      summary[3] = totalActualSale > 0 ? _i18n.default.t('Order.Total') + ': $' + totalActualSale.toFixed(0) + ' | Avg: $' + (actualSaleCount ? totalActualSale / actualSaleCount : 0).toFixed(0) : null;

      // summary[4] = 'Total: $' + totalEstimatedSale.toFixed(0) + ' | Avg: $' + (estimatedSaleCount ? totalEstimatedSale / estimatedSaleCount : 0).toFixed(0)

      summary[5] = _i18n.default.t('Order.Total') + ': $' + totalDutyCost.toFixed(0) + ' | Avg: $' + (dutyCostCount ? totalDutyCost / dutyCostCount : 0).toFixed(0);
      summary[6] = _i18n.default.t('Order.Total') + ': ' + (totalDutyManHr ? totalDutyManHr.toFixed(0) : 0) + 'hr' + ' | Avg: ' + (dutyManHrCount ? totalDutyManHr / dutyManHrCount : 0).toFixed(0) + 'hr';
      return summary;
    }
  }
};
exports.default = _default;